//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppHeader from '~/components/AppHeader.vue';
import BottomNavigation from '~/components/BottomNavigation.vue';
import AppFooter from '~/components/AppFooter.vue';
import TopBar from '~/components/TopBar.vue';
import CartSidebar from '~/components/CartSidebar.vue';
import WishlistSidebar from '~/components/WishlistSidebar.vue';
import MessageSiderbar from '~/components/MessageSidebar.vue';
import LoginModal from '~/components/LoginModal.vue';
import LazyLogin from '~/components/LazyLogin.vue';
import LazyHydrate from 'vue-lazy-hydration';
import Notification from '~/components/Notification';
import floatButtons from '~/components/floatButtons.vue';
import { onSSR } from '@vue-storefront/core';
import {
  useRoute,
  watch,
  useRouter,
  onMounted,
  computed,
  ref,
  onUnmounted,
  onBeforeUnmount
} from '@nuxtjs/composition-api';
import BottomCookie from '~/components/Bottom/CookieModal';
import { useCustomerStore } from '~/stores/customer';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import {
  useUser,
  useOCart,
  useStore,
  useWishlist,
  useApiError,
  useOauth,
  useGuest,
  usePrePayList,
  useCredential
} from '@bee-hole/coms';
import { useUiNotification, useUiState } from '~/composables';

export default {
  name: 'DefaultLayout',

  components: {
    LazyHydrate,
    TopBar,
    AppHeader,
    BottomNavigation,
    AppFooter,
    CartSidebar,
    WishlistSidebar,
    MessageSiderbar,
    LoginModal,
    Notification,
    BottomCookie,
    floatButtons,
    LazyLogin
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const meta = this?.configs?.meta || [];
    const link = this?.configs?.link || [];

    const mates = meta.map((mitem) => {
      if (mitem.name) {
        return { name: mitem.name, content: mitem.content };
      } else {
        return { charset: mitem.charset };
      }
    });
    let cssText = '';
    cssText = this?.configs?.css?.value
    if (this?.configs?.TopBar?.color) {
      cssText += ("--top-bar-background:" + this?.configs?.TopBar?.color + ';');
    }
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs
        // myAttribute: this?.configs?.title,
      },
      title: this?.configs?.title,
      meta: [...mates, ...i18nHead.meta],
      link: [...link, ...i18nHead.link],
      style: [
        {
          cssText: `html{${cssText}}`
        }
      ]
    };
  },
  setup(p, context) {
    const { getPinJu, result: pingju } = useCredential();
    const {
      root: {
        $nuxt,
        $cookies,
        $i18n,
        $options: { $xreq }
      },
      root
    } = context;
    $i18n.__baseUrl = 'https://' + $xreq.host;
    const notificationId = ref();
    const route = useRoute();
    const { isLoginModalOpen, toggleLoginModal, resize, toggleCartSidebar } = useUiState();
    const { getPrePayList, prepaylist } = usePrePayList('defaultPrePay');
    const { load: loadStores } = useStore();
    const { load: loadUser, isAuthenticated } = useUser();
    // const { relationAdd, result: relationRes } = useRelation();
    const { refreshToken } = useOauth();
    const { load: loadCart, addItem, loading: cartLoading } = useOCart();
    const { load: loadWishlist } = useWishlist();
    const { setToken, getToken } = useGuest();
    const { error } = useApiError();
    const router = useRouter();
    const notify = useUiNotification();
    const configs = computed(
      () => context?.root?.$options?.$mallConfig?.mall_web_config
    );
    const customerStore = useCustomerStore();
    const previewOrderStore = usePreviewOrderStore();
    const PreTime = ref();
    const timeoutId = ref();
    const getPrePayOrder = async () => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
      }
      await getPrePayList({
        user_id: $cookies.get('userKey'),
        from_id: $cookies.get('tokenkey')
      });
      if (prepaylist.value?.list?.length) {
        PreTime.value && clearTimeout(PreTime.value);
        await getPinJu({ prepay_id: prepaylist.value?.list[0]?.prepay_id });
        if (pingju.value?.credential_id) {
          router.push(
            root.localePath(
              '/xpay?orderNumber=' +
                prepaylist.value?.list[0]?.prepay_id +
                '&credential_id=' +
                pingju.value?.credential_id
            )
          );
        }
      } else {
        PreTime.value = setTimeout(() => {
          getPrePayOrder();
        }, 1000);
      }
    };
    const getCart = async () => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
      }
      const cartData = await context.root.$vsf.$xbuy.api.customCartLoad({});
      const setType = cartData?.data?.setType;
      if (String(setType) === '1') {
        // PreTime.value && clearTimeout(PreTime.value);
        router.push(root.localePath('/checkout/shipping'));
      }
      PreTime.value = setTimeout(() => {
        getCart();
      }, 1000);
    };
    const shouyinLoad = () => {
      // console.log('收银台轮询++++++++++++');
      if (customerStore.settlement === 1) {
        getCart();
      } else if (customerStore.settlement === 2) {
        getPrePayOrder();
      }
    };
    onUnmounted(() => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
        customerStore.setIsGoPay(false);
      }
    });
    onBeforeUnmount(() => {
      if (PreTime.value) {
        clearTimeout(PreTime.value);
        customerStore.setIsGoPay(false);
      }
      if (process.client) {
        // 清除 resize 事件处理器
        window.onresize = null;
        if (timeoutId.value !== null) {
          // 清理定时器
          clearTimeout(timeoutId.value);
        }
      }
    });
    const authenticatedFcn = async () => {
      if (isAuthenticated.value || $cookies.get('token')) {
        await loadUser();
        if (route.value?.path?.indexOf('/checkout') === -1) {
          await loadCart();
          await loadWishlist();
        }
      } else {
        // const distcode = route.value.query.distributor_code;
        // if (distcode) {
        //   await relationAdd({ distributor_code: distcode });
        // }
      }
    };
    onMounted(async () => {
      if (window) {
        window.onresize = resize;
      }
      if (process.client) {
        timeoutId.value = setTimeout(() => {
          resize();
        }, 100);
      }
      if (route.value?.query?.settlement) {
        customerStore.setSettlement(Number(route.value?.query?.settlement));
      }
      if (route.value?.query?.tokenkey) {
        $cookies.set('tokenkey', route.value?.query?.tokenkey, {
          path: '/',
          sameSite: 'Lax',
          maxAge: 3600 * 24 * 31
        });
        if (route.value?.query?.suiji) {
          previewOrderStore.reset();
          $cookies.remove('token');
          await getToken({ key: route.value?.query?.tokenkey });
          // customerStore.setToken(guest.value?.token);
          await loadUser();
          customerStore.setisSetToken(true);
        } else {
          customerStore.setisSetToken(false);
          customerStore.setIsGoPay(false);
        }
        if (!$cookies.get('token')) {
          toggleLoginModal();
        }
        if (!customerStore?.isGoPay) {
          shouyinLoad();
          customerStore.setIsGoPay(true);
        }
      }
      if (route.value?.query?.userKey) {
        $cookies.set('userKey', route.value?.query?.userKey, {
          path: '/',
          sameSite: 'Lax',
          maxAge: 3600 * 24 * 1
        });
      }
      if (route.value?.query?.token) {
        $cookies.set('token', route.value?.query?.token, {
          path: '/',
          sameSite: 'Lax',
          maxAge: 3600 * 24 * 365
        });
        await refreshToken();
        router.push(root._route.path);
        await loadUser();
        loadCart();
        loadWishlist();
      }
      if (route.value?.query?.path) {
        customerStore.setLoginPath(route.value?.query?.path);
      }
      const newtoken = $cookies.get('token');
      const tokenkey = $cookies.get('tokenkey');
      if ((!customerStore?.isGoPay || !PreTime.value) && tokenkey) {
        shouyinLoad();
        customerStore.setIsGoPay(true);
      }
      if (tokenkey && !customerStore?.isSetToken && newtoken) {
        await setToken({ key: tokenkey });
        customerStore.setisSetToken(true);
        if (!PreTime.value) {
          shouyinLoad();
          customerStore.setIsGoPay(true);
        }
      }
      if (route.value?.query?.path === 'Shipping') {
        router.push(context.root.localePath('/my-account/Shipping'));
      } else if (route.value?.query?.path === 'order') {
        await loadCart();
        router.push(context.root.localePath('/checkout/shipping'));
      }
      authenticatedFcn();
    });
    const handleActionClick = () => {
      notify.dismiss(notificationId.value);
      router.push(context.root.localePath('/my-account/History?open=2'));
    };
    const addToCart = async (sku) => {
      await addItem({ customQuery: { skuId: sku.skuId }, product: { goodId: sku.goodId }, quantity: 1 });
      if (!cartLoading.value) {
        await notify.dismiss(notificationId.value);
        toggleCartSidebar();
      }
    };
    watch(error, async () => {
      if (error.value.code === 61) {
        if (!isLoginModalOpen.value) {
          toggleLoginModal();
        }
      } else {
        if (error.value.code === 2201) {
          return false;
        }
        let action = {};
        if (error.value.code === 3208 || error.value.code === 3128) {
          action = {
            text: $nuxt.$t('go_to_see_prepid'),
            onClick: handleActionClick
          };
        }
        if (error.value?.message) {
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'success' : 'danger',
            message:
              (error.value.code !== 0 ? error.value.code + ': ' : '') +
              String($nuxt.$t(error.value.message)),
            persistent: true,
            time: error.value.time || 0,
            action
          });
        }
        if (error.value.image) {
          await notify.dismiss(notificationId.value);
          // 等待1秒
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 300);
          });
          if (error.value.sku) {
            action = {
              text: $nuxt.$t('add_To_Cart'),
              onClick: () => addToCart(error.value.sku),
              type: 'primary'
            };
          }
          notificationId.value = notify.send({
            type: error.value.code === 0 ? 'info' : 'danger',
            image: error.value.image,
            persistent: false,
            time: error.value.time || 0,
            class: 'notificationImage',
            action,
            sku: error.value.sku
          });
        }
        action = {};
      }
    });
    onSSR(async (ctx) => {
      if (ctx?.$root?.$options?.$xreq?.host) {
        ctx.$root.$i18n.__baseUrl = 'https://' + ctx.$root.$options.$xreq.host;
      }
      if (route.value.query.ref) {
        $cookies.set("distributor_code", route.value.query.ref, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 31
        });
      }
      if (context.root?.$options?.$storeConfig && context.root?.$options?.$storeConfig?.mall_registry_settings) {
        await loadStores();
      } else {
        context.root.context.ssrContext.res.statusCode = 500; // 设置状态码为 500（内部服务器错误）
        context.root.context.ssrContext.res.end(`${context.root?.$options?.$storeConfig.error.message}`); // 输出错误消息到浏览器
      }
      await Promise.all([
        loadStores(),
        loadUser()
      ]);
    });

    return {
      route,
      configs,
      isAuthenticated
    };
  }
};
